"use strict";

var ubian = ubian || {};

ubian.globalNotice = {
  noticeVersion: 2
};

ubian.globalNotice.init = function() {
  var lastShown = Cookies.get("global_notice_shown");
  if (
    /*$(".navigation").length > 0 &&*/
    (!lastShown || parseInt(lastShown) < ubian.globalNotice.noticeVersion) &&
    !$("body").hasClass("appmode")
  ) {
    ubian.globalNotice.show();
  }
};

ubian.globalNotice.show = function() {
  return;
  /*var maxDate = moment("2020-02-24 06:00:00");
  if (moment() >= maxDate) {
    return;
  }*/
  var template =
    '<div class="global-notice js-global-notice"><span>UPOZORNENIE: V dňoch 21. a 22. februára 2020 vždy od 22:00 do 23:59 hod nebude možné realizovať platby za objednávky cez e-shop UBIAN. Ďakujeme za pochopenie.</span><button class="btn pull-right js-global-notice-ok">OK</button></div>';
  $("body").append(template);
  $("body").on("click", ".js-global-notice-ok", function() {
    var d = new Date();
    Cookies.set("global_notice_shown", ubian.globalNotice.noticeVersion, {
      expires: 365
    });
    $(".js-global-notice").fadeOut();
  });
};
